// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VLep","clinicsSelect":"styles_clinicsSelect__3APgt"};